export default "__VITE_ASSET__BVSN7qml__"